<ion-content>
  <ion-grid>
    <ion-row class="header-mini-basket">
      <ion-col size="1.5"></ion-col>
      <ion-col class="mini-title">
        <h3>Basket</h3>
      </ion-col>
      <ion-col class="close-mini-basket" (click)="dismiss()" size="1.5">
        <img src="../../../assets/icon/close.svg" alt="close">
      </ion-col>
    </ion-row>
    <ng-container *ngIf="cartLoading">
      <ion-row *ngFor="let item of [1,2,3,4]">
        <ion-col>
          <ion-skeleton-text [animated]="true" style="height: 40px;width: 100%"></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ng-container>
    <ng-container *ngIf="(!cartLoading && +cartData?.cart_items === 0) || !currentCartId">
      <ion-row class="empty-row">
        <ion-col class="empty-basket">
          <img src="../../../assets/icon/basket-empty.svg" alt="basket icon"/>
          <h3>Your basket is empty</h3>
        </ion-col>
      </ion-row>
    </ng-container>
    <ion-row class="cart-item-box">
      <ion-col>
        <ion-row class="cart-item" *ngFor="let item of cartData?.cart_items;let i=index">
          <ion-col size="auto" class="cart-item-img">
            <a href="/products/{{item.catalog_alias}}/{{item.collection_alias}}/{{item.id}}/{{item.title_alias}}">
            <img src="{{item.image}}" alt="{{item.title}}">
            </a>
          </ion-col>
          <ion-col class="basket-item-info">
            <ion-row class="item-basket-title">
              <ion-col>
                <a href="/products/{{item.catalog_alias}}/{{item.collection_alias}}/{{item.id}}/{{item.title_alias}}">
                <h4>{{item.title}}</h4>
                </a>
              </ion-col>
            </ion-row>
            <ion-row class="item-basket-price">
              <ion-col>
                <span>{{item.amount}}<ng-container *ngIf="appInitData"> x {{item.unit_price}}</ng-container> </span>
              </ion-col>
            </ion-row>
            <ion-row class="qty-btn-holder">
              <ion-col>
                <ion-button (click)="subItemQty(item,i)" class="qty-btn minus-qty">
                  <img *ngIf="!item?.subCount || item.subCount===0" src="../../../assets/icon/minus.svg" alt="minus"/>
                  <span *ngIf="item?.subCount && item.subCount>=1">-{{item.subCount}}</span>
                </ion-button>
                <ion-button (click)="addItemQty(item)" class="qty-btn plus-qty">
                  <img *ngIf="!item?.addCount" src="../../../assets/icon/plus.svg" alt="plus"/>
                  <span *ngIf="item?.addCount && item.addCount>=1">+{{item.addCount}}</span>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="remove-basket-item" size="auto" (click)="deleteItem(item,i)">
            <img src="../../../assets/icon/close.svg" alt="close">
          </ion-col>
        </ion-row>

      </ion-col>
    </ion-row>
    <ion-row *ngIf="+cartData?.cart_items !== 0 && !cartLoading && currentCartId" class="bottom-mini-cart">
      <ion-col>
        <ion-row *ngIf="appInitData" class="sub-total-mini">
          <ion-col size="auto">
            <label>Total Basket:</label>
          </ion-col>
          <ion-col class="mini-cart-b">
            <ion-skeleton-text *ngIf="softLoadingCart || cartLoading" animated="true" class="total-price-skel"></ion-skeleton-text>
            <b *ngIf="!softLoadingCart && !cartLoading">${{cartData?.total_price}}</b>
          </ion-col>
        </ion-row>
        <ion-row class="mini-btns">
          <ion-col size="5.8">
            <ion-button (click)="redirectToCart()" class="view-basket">View basket</ion-button>
          </ion-col>
          <ion-col></ion-col>
          <ion-col size="5.8">
            <ion-button (click)="dismiss()" class="shopping-basket">Continue shopping</ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
